import React from 'react';
import { CalendarCheckIcon, GalleryHorizontalEndIcon, NotebookPenIcon, PuzzleIcon, RecycleIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
const ICONS = {
  recycle: RecycleIcon,
  cards: GalleryHorizontalEndIcon,
  notebook: NotebookPenIcon,
  puzzle: PuzzleIcon,
  calendar: CalendarCheckIcon
};
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-brand-cream text-brand-navy" data-id="element-27" data-mp="14s9lx3gyxq2j">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="ztg8tc5lg12w">
        <h2 id="bonos" className="font-display text-4xl leading-none sm:text-5xl" data-id="element-29" data-mp="1ej49cb5yavpk">
          <span className="rounded-lg bg-brand-yellow px-2" data-id="element-30" data-mp="1el8fz0v8i8tj">5 Bonos incluidos</span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-31" data-mp="19mndeusifd1x">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-brand-green" data-id="element-32" data-mp="1jj9wpf56tw1u">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="3prwlqvr9y5wc">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-xl border-2 border-brand-orange bg-white text-left" data-id="element-34" data-mp="2l2ug58q4ofz" data-mpi={i}>
                <span className="flex items-center gap-1.5 bg-brand-orange px-2.5 py-1 font-sub text-sm font-bold text-brand-navy" data-id="element-35" data-mp="chpi11sfptlp">
                  <Icon size={14} aria-hidden="true" data-id="element-36" data-mp="lcdnary0fbai" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="qbghfhcgbx3p">
                  <h3 className="font-sub text-sm font-bold leading-tight" data-id="element-38" data-mp="qd1djbeezo3o">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-39" data-mp="108l4rki19ym3">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1.5 text-xs font-bold text-brand-muted" data-id="element-40" data-mp="alidso9qw8l2">
                    Valor: <span className="line-through decoration-2" data-id="element-41" data-mp="5np77u4j5ck9">{bono.value}</span>
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-brand-orange bg-brand-navy px-3 py-2.5 leading-tight" data-id="element-42" data-mp="fjjyfdmtkfyn">
          <p className="font-sub text-base font-bold text-white" data-id="element-43" data-mp="tdtcs71a3mdw">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-brand-gold line-through decoration-2" data-id="element-44" data-mp="oezve3ivfb8g">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-sans text-sm font-extrabold uppercase text-brand-yellow" data-id="element-45" data-mp="yatj8j21ir5j">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}